import { render, staticRenderFns } from "./editCampaign.vue?vue&type=template&id=54e5286a&scoped=true&"
import script from "./editCampaign.vue?vue&type=script&lang=js&"
export * from "./editCampaign.vue?vue&type=script&lang=js&"
import style0 from "./editCampaign.vue?vue&type=style&index=0&id=54e5286a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5286a",
  null
  
)

export default component.exports